import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { FAQ as FAQComponent } from '../components/FAQ';
export const FAQ: React.FC = () => {
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <div className="bg-white" data-id="element-284">
      {/* Hero Section */}
      <section className="bg-black text-white py-16 md:py-24" data-id="element-285">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-286">
          <motion.div className="max-w-3xl mx-auto text-center" initial="hidden" animate="visible" variants={fadeIn} data-id="element-287">
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-6" data-id="element-288">
              Frequently Asked Questions
            </h1>
            <p className="text-xl text-gray-300" data-id="element-289">
              Get answers to common questions about our business debt rescue
              service
            </p>
          </motion.div>
        </div>
      </section>
      {/* FAQ Section */}
      <section className="py-16 md:py-24 bg-white" data-id="element-290">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-291">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={fadeIn} data-id="element-292">
            <FAQComponent data-id="element-293" />
          </motion.div>
        </div>
      </section>
      {/* Additional Help */}
      <section className="py-16 bg-gray-50" data-id="element-294">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-295">
          <motion.div className="max-w-3xl mx-auto text-center" initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={fadeIn} data-id="element-296">
            <h2 className="text-3xl font-bold mb-6" data-id="element-297">Still Have Questions?</h2>
            <p className="text-xl text-gray-600 mb-8" data-id="element-298">
              Contact us directly for a confidential discussion about your
              specific situation.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-299">
              <a href="https://wa.me/YOURPHONENUMBER" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors" data-id="element-300">
                Contact via WhatsApp
              </a>
              <a href="https://t.me/YOURUSERNAME" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-301">
                Contact via Telegram
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
};